import styled from 'styled-components';
import * as glx from 'assets/css/glx';

export const BgImg = glx.BgImg;

export const LoginForm = styled.div`
  /* box-sizing: border-box; */
  position: relative;

  > .close {
    position: absolute;
    width: 38px;
    height: 33px;
    display: block;

    right: 0;
    top: -7px;
    transform: translateY(-100%);

    > .bg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1000;

      background-image: url(${require('../img/close.png')});
      background-size: 100% 100%;
      transform: scale(1.6);
    }

    &:hover {
      > .bg {
        background-image: url(${require('../img/close-active.png')});
      }
    }
  }
`;

export const TitleFloor = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  padding-top: 62px;
`;

export const TitleText = styled.img`
  width: 110px;
  height: 50px;
  transform: scaleX(1.2) scaleY(1.2);
`;

export const TitleBgImg = styled.img`
  width: 154px;
  height: 153px;
  position: absolute;
  top: 0;
  z-index: -1000;

  left: 0;
  right: 0;
  margin: auto;
`;

export const Form = styled.form`
  margin-top: 45px;
`;

export const FormItem = styled.div.attrs(props => ({
  className: 'form-item'
}))`
  &.form-item {
    width: 347px;
    height: 56px;
    margin: auto;
    /* margin-top: ${props => (props.first ? 'unset' : '16px')}; */
    margin-bottom:26px;
  }
`;

export const InputBlock = styled.div`
  width: 347px;
  height: 56px;
  margin: auto;
  position: relative;
`;

export const InputIcon = styled.img`
  width: 16px;
  height: 20px;

  position: absolute;
  left: 21px;
  top: 0;
  bottom: 0;
  margin: auto;
`;

export const Input = styled.input`
  width: 100%;
  height: 100%;
  padding-left: 56px;
  padding-right: 20px;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(254, 254, 254, 1);
  opacity: 0.6;
  ::placeholder {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(254, 254, 254, 1);
    opacity: 0.6;
  }
`;

export const SaveBlock = styled.div`
  width: 347px;
  margin: auto;
  /* margin-top: 13px; */
  display: flex;
  align-items: center;
`;

export const SaveCheckbox = styled.div`
  /* width: 16px;
  height: 16px;
  background: rgba(47, 99, 126, 0.3);
  border: 1px solid rgba(26, 62, 81, 1); */
`;

export const SaveText = styled.span`
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  display: block;
  margin-left: 6px;
`;

export const RegisterText = styled.span`
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  display: block;
  margin-left: auto;
  cursor: pointer;
`;

export const RegisterIcon = styled.img`
  margin-left: 6px;

  width: 16px;
  height: 12px;
  display: block;
  cursor: pointer;
`;

export const LoginButton = styled.button`
  width: 266px;
  height: 52px;
  box-shadow: 0px 0px 8px 0px rgba(9, 9, 10, 0.14);

  margin: auto;
  margin-top: 37px;
  position: relative;

  display: block;
`;

export const ThirdParty = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: 193px;

  padding-top: 30px;
  box-sizing: border-box;
  text-align: center;
`;

export const ThirdPartyText = styled.div`
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
`;

export const ThirdPartyBgImg = styled(BgImg)`
  height: 183px;
  transform: scale(0.8, 0.8);
`;
